module.exports = __webpack_public_path__ + "static/media/COS_ZENTIVA.99fc5963.jpeg";